import React from 'react';
import Page from '../Page/Page';
import { platform_base_url, http_404 } from '../../util/config';

/**
 * A wrapper for the 404 page
 */
const NotFoundPage = () => <Page endpoint={platform_base_url} id={http_404} />;

export default NotFoundPage;
